import React, { memo } from "react";
import * as Sentry from "@sentry/react";
import ErrorFallback from "../Errors/ErrorFallback";
import { handleKeyboardActivation } from "src/utils/accessibility";

type CardProps = {
  onClick?: () => void;
  className?: string;
  children: React.ReactNode;
  style?: React.CSSProperties;
  dataTestId?: string;
};

function Card({ onClick, className, children, style, dataTestId }: CardProps) {
  return (
    <div
      className={`${"card"} ${className}`}
      style={style}
      data-testid={dataTestId || "card"}
      onClick={onClick}
      onKeyDown={
        onClick ? (e) => handleKeyboardActivation(e, onClick) : undefined
      }
      role={onClick ? "button" : undefined}
      tabIndex={onClick ? 0 : undefined}
    >
      <Sentry.ErrorBoundary
        fallback={({ error, resetError }) => (
          <ErrorFallback error={error} onReload={resetError} />
        )}
      >
        {children}
      </Sentry.ErrorBoundary>
    </div>
  );
}

export default memo(Card);
